import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { B2bDynamicLoaderPipe } from '@app/b2b-dynamic-lib/pipes/b2b-dynamic-loader-pipe.pipe';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { B2bDynamicLoaderDirective } from '@app/b2b-dynamic-lib/directives/b2b-dynamic-loader.directive';
import {
  ClientProductRatePlanModel,
  ClientProductRoomModel,
  ClientSelectedRoom,
  ContainerItemModel,
} from '@app/models/server/layout.model';
import { SelectedItem } from '@app/models/client/item.model';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { environment } from '@src/environments/environment';
import { OverlayEventDetail } from '@ionic/core';
import { ModalController } from '@ionic/angular/standalone';
import { B2bPopoverV1Component } from '@app/new-ui-lib/b2b-popover-v1/b2b-popover-v1.component';

@Component({
  selector: 'app-room-guest-form',
  templateUrl: './room-guest-form.component.html',
  styleUrls: ['./room-guest-form.component.scss'],
  standalone: true,
  imports: [
    B2bDynamicLoaderPipe,
    B2bDynamicLoaderDirective,
    AsyncPipe,
    B2bPopoverV1Component,
    NgTemplateOutlet,
  ],
})
export class RoomGuestFormComponent implements OnInit {
  @Input() compData: {
    roomData: ClientProductRoomModel;
    selectedRoom: ClientSelectedRoom;
    ratePlan: ClientProductRatePlanModel;
    // ratePlanIndex: number;
    // selectedRoomIndex: number;
  };

  @ViewChild('roomGuestPopover') roomGuestPopover: B2bPopoverV1Component;

  @Output() selected: EventEmitter<SelectedItem> = new EventEmitter<any>();

  selectedRoomGuestData: {
    containerItem: ContainerItemModel;
    selectedValue: SelectedItem;
    restrictions?: {
      maxRooms: number;
      maxAdults: number;
      maxChildren: number;
      maxTotalGuestAllowed: number;
      hideRooms: boolean;
      disableDefaultValues: boolean;
      checkMaxGuestOccupancyInRoom: boolean;
    };
  };

  roomGuestFieldContainer: ContainerItemModel;

  randomNumber: number = Math.floor(Math.random() * (100000 - 1000 + 1) + 1000);

  isMobile: boolean =
    environment?.mobileApp || !this.b2bDeviceUtilService.isDesktop();

  constructor(
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private modalController: ModalController,
  ) {}

  ngOnInit() {
    this.setSelectedRoomGuestData();
  }

  onOpenRoomGuestElement() {
    if (this.isMobile) {
      this.onOpenRoomGuestModal().then();
    } else {
      // this.onOpenRoomGuestPopover();
    }
  }

  async onOpenRoomGuestModal() {
    const dynamicComp = await import(
      '@app/new-ui-lib/b2b-guest/components/b2b-popover-room-guest-field/b2b-popover-room-guest-field.component'
    ).then((m) => m.B2bPopoverRoomGuestFieldComponent);

    const modal: HTMLIonModalElement = await this.modalController.create({
      component: dynamicComp,
      componentProps: {
        compData: this.selectedRoomGuestData,
        isModal: true,
        title: this.selectedRoomGuestData?.containerItem?.placeholder,
      },
      initialBreakpoint: 1,
      breakpoints: [0, 1],
    });

    modal.onDidDismiss().then((result: OverlayEventDetail<SelectedItem>) => {
      if (result && result.data) {
        this.setFieldValue(result.data, this.selectedRoomGuestData);
      }
    });

    return await modal.present();
  }

  setSelectedRoomGuestData() {
    this.roomGuestFieldContainer = JSON.parse(
      JSON.stringify(this.compData?.roomData?.roomGuestFieldContainer),
    );

    this.selectedRoomGuestData = {
      containerItem: this.roomGuestFieldContainer,
      selectedValue: this.compData?.selectedRoom?.selectedValues,
      restrictions: {
        maxRooms: 1,
        maxAdults: this.compData?.ratePlan?.maxEntity,
        maxChildren: this.compData?.ratePlan?.maxChildren,
        maxTotalGuestAllowed: this.compData?.ratePlan?.maxTotalGuestAllowed,
        hideRooms: true,
        disableDefaultValues: true,
        checkMaxGuestOccupancyInRoom: true,
      },
    };
  }

  setFieldValue(
    selectedValue: SelectedItem,
    selectedCompData: {
      containerItem: ContainerItemModel;
    },
  ) {
    this.selected.emit(selectedValue);
  }

  dismissPopover(
    popover: B2bPopoverV1Component,
    currentCompData: {
      containerItem: ContainerItemModel;
      selectedValue: SelectedItem;
    },
  ) {
    popover?.close();
  }
}
